var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IPushNotificationsRepositoryType } from '../../../Interfaces/IPushNotificationsRepository';
import { ICoordinatorServiceType } from '../../../Services/CoordinatorService/ICoordinatorService';
import { inject } from '../../../../Data/Decorators/Inject';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { Observable } from '../../../../Data/Observable/Observable';
let GetPushNotificationUseCase = class GetPushNotificationUseCase {
    constructor(pushNotificationRepository, coordinatorService) {
        this.pushNotificationRepository = pushNotificationRepository;
        this.coordinatorService = coordinatorService;
        this.pushNotification = new Observable(null);
    }
    execute(id) {
        return this.pushNotificationRepository.getPushNotification(id)
            .then(obs => {
            obs.observe(this, notification => {
                if (!notification) {
                    this.pushNotification.next(null);
                    return;
                }
                const newNotification = Object.assign(Object.assign({}, notification), { interactions: [
                        {
                            type: 'primary',
                            action: 'notification_cta',
                            text: notification.cta_title || 'Ok',
                            onPress: () => {
                                if (notification.deep_link) {
                                    return this.coordinatorService.dismissPushNotifications(notification.id)
                                        .then(() => new Promise((res) => setTimeout(res, 300)))
                                        .then(() => this.coordinatorService.navigateToDeepLink(notification.deep_link))
                                        .catch(error => this.coordinatorService.showError({ description: error.message }));
                                }
                                return this.coordinatorService.dismissPushNotifications(notification.id);
                            }
                        }
                    ] });
                this.pushNotification.next(newNotification);
            });
            return this.pushNotification;
        });
    }
};
GetPushNotificationUseCase = __decorate([
    injectable(),
    __param(0, inject(IPushNotificationsRepositoryType)),
    __param(1, inject(ICoordinatorServiceType)),
    __metadata("design:paramtypes", [Object, Object])
], GetPushNotificationUseCase);
export { GetPushNotificationUseCase };
